import { AfterContentChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { DateFormatService, MenuService } from '../../../../services';
import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

@Component({
  selector: 'app-date-renderer',
  templateUrl: './date-renderer.component.html',
  styleUrl: './date-renderer.component.scss',
  imports: [NgbInputDatepicker],
})
export class DateRendererComponent
  extends BaseRendererComponent
  implements AfterContentChecked, ICellRendererAngularComp
{
  protected readonly menuService = inject(MenuService);
  protected readonly dateFormatService = inject(DateFormatService);
  private readonly cdRef = inject(ChangeDetectorRef);

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  onDateChanged(dateString: string) {
    const date = this.dateFormatService.dateFromString(dateString);
    this.params.node.setDataValue(this.params.column.getColId(), date);
  }

  onDatePicked(ngbDate: NgbDateStruct) {
    const date = this.dateFormatService.dateFromNgbDate(ngbDate);
    this.params.node.setDataValue(this.params.column.getColId(), date);
  }
}
